var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBmw(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2C8.268 2 2 8.268 2 16s6.268 14 14 14 14-6.268 14-14S23.732 2 16 2z",
    fill: "url(#paint0_linear_109_812)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24.943a8.943 8.943 0 110-17.886 8.943 8.943 0 010 17.886z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.633 16H16V7.632A8.368 8.368 0 007.633 16zM16 16v8.367A8.367 8.367 0 0024.368 16H16z",
    fill: "url(#paint1_linear_109_812)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.244 7.36c.43-.268.888-.18 1.184.107.456.443.389.955-.044 1.471l-1.897 2.26-2.826-2.372 1.798-2.143c.372-.443.892-.797 1.387-.382l.026.022c.135.112.202.168.376.486a.818.818 0 01-.004.55zm-.803-.137c-.181-.152-.464-.158-.59-.01l-1.08 1.288.669.56L7.508 7.79c.134-.16.133-.398-.067-.566zm.185 2.834l1.126-1.342c.15-.178.128-.456-.09-.639-.193-.162-.48-.117-.607.036L6.92 9.464l.706.593z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.44 3.876l-.971 2.573h-.806l-.971-2.573V6.45h-.738V2.764h1.109l1.003 2.625 1.003-2.625h1.108V6.45h-.738V3.876zM24.999 9.949l1.389-1.967-.612-.755-2.212.95 1.447-1.894-.57-.704-2.312 2.973.676.828 2.184-.899.008.01-1.333 1.95.669.832 3.39-1.642-.571-.705-2.153 1.023z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_812",
    x1: 6.277,
    y1: 6.277,
    x2: 25.183,
    y2: 26.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#949AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#1A1D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#040606"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_109_812",
    x1: 16,
    y1: 7.632,
    x2: 16,
    y2: 24.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CD1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1274B9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmw);
export default __webpack_public_path__ + "static/media/bmw.6bcf9ed6dc02c29ee86a3cf68527b870.svg";
export { ForwardRef as ReactComponent };